import { Partial } from '@40seas/entities/common';
import { StripeCustomer } from './stripe-customer.entity';

export class UpdateStripeCustomerDto extends Partial(StripeCustomer) {}
